<span *ngIf="total !== null">
    {{'Total_Records' | translate:{ totalRecords: total} }}
</span>
